import styled from 'styled-components';
import { Panel } from '@/ui/Panel/Panel';

export const PostCardSurface = styled(Panel).attrs({ as: 'article', $surfaceRole: 'reading' })<{
  $compact?: boolean;
}>`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  min-width: 0;
  gap: ${({ $compact }) => ($compact ? '6px' : '10px')};
  /* Feed-density pref (Settings → Content Preferences): viewer-side spacing only. */
  padding: ${({ $compact }) => ($compact ? '10px 12px 6px' : '20px 20px 8px')};

  @media (max-width: 767.98px) {
    padding: ${({ $compact }) => ($compact ? '10px 12px 6px' : '16px 16px 8px')};
  }
`;
